import { render, staticRenderFns } from "./DietCard.vue?vue&type=template&id=9443b984&"
import script from "./DietCard.vue?vue&type=script&lang=js&"
export * from "./DietCard.vue?vue&type=script&lang=js&"
import style0 from "./DietCard.vue?vue&type=style&index=0&id=9443b984&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports